import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const StatusOrderModule = lazy(loadModule);

export default StatusOrderModule;
